import { React, classNames} from '@api'
import * as css from './Divider.css'

export const Divider = ({className, ...props}: React.HTMLAttributes<HTMLDivElement> & {className?: string}) => <hr {...props} className={classNames(css.root, className)} />



// WEBPACK FOOTER //
// ./src/modules/whiteboard/components/Divider/Divider.tsx